module.exports = __webpack_public_path__ + "img/violet_074.282a36f4.png";